import { MetalworksAnalytics } from '../../systems/analytics'
import { useCloneConfiguration } from '../hooks/use-clone-configuration'
import { LoadingButton } from './LoadingButton'

export const CloneNewButton = () => {
  const { isPending, cloneAndStart } = useCloneConfiguration(MetalworksAnalytics.CloneConfigurationButtonClicked())

  return (
    <LoadingButton isPending={isPending} onClick={cloneAndStart}>
      Start from existing
    </LoadingButton>
  )
}
